import $config from "@/app.config.js";
import $store from "@/store";
import $router from "@/router";
import successIcon from "@/assets/svg/icons/v2-toast-success.svg";
import errorIcon from "@/assets/svg/icons/v2-toast-error.svg";
import Pusher from "pusher-js";
import { i18n } from "@/main.js";
import { EventBus } from "@/assets/js/event-bus.js";

let pusherInstance = null;

export default {
  init: (team) => {
    console.log("***** PUSHER INIT *****", pusherInstance);
    if (pusherInstance) {
      pusherInstance.disconnect();
    }
    pusherInstance = new Pusher($config.pusher.appKey, {
      cluster: $config.pusher.appCluster,
      authEndpoint: $config.api.invokeUrl + "/" + team + "/broadcasting/auth/",
      auth: {
        headers: {
          Authorization: "Bearer " + $store.getters.auth_get_teams[team].token,
        },
      },
    });
  },
  unsubscribe: (team, account) => {
    console.log("***** PUSHER UNSUBSCRIBE *****", team, $store.getters.auth_get_teams[team]);
    $store.commit("GLOBAL_SET_PUSHER_INIT", { teamUid: team, state: false });
    if (pusherInstance) {
      pusherInstance.unsubscribe("private-backoffice.user-notification." + team + "." + account);
    }
  },
  subscribe: (team, snotify) => {
    console.log("***** PUSHER SUBSCRIBE *****", team);
    if ($store.getters.auth_get_teams[team].account.uid) {
      const channel = pusherInstance.subscribe(
        "private-backoffice.user-notification." + team + "." + $store.getters.auth_get_teams[team].account.uid
      );
      channel.bind("Illuminate\\Notifications\\Events\\BroadcastNotificationCreated", (data) => {
        if (!$store.getters.global_get_teams_settings[team].pusherInitialized) {
          return;
        }

        if (data.uid) {
          console.log("PUSHER NOTIFICATION: ", data);
          // set the seen notification status only for events with an 'uid' attribute
          $store.dispatch("setSingleNotificationStatus", {
            notification: data.uid,
            params: {
              seen_at: true,
            },
          });
        }
        EventBus.$emit("getMessagesCounter");
        if (data.short_type) {
          if (data.short_type === "project_message" && $router.currentRoute.name === "Inbox") {
            EventBus.$emit("reloadProjectsWithMessages", data.project_uid);
          }
          if (
            (data.short_type === "file_approval_version_approved" ||
              data.short_type === "file_approval_version_rejected") &&
            $router.currentRoute.name === "Project" &&
            $router.currentRoute.params.tab === "fileapproval"
          ) {
            EventBus.$emit("fileApprovalListReloadEvent");
          }
          if (
            data.short_type === "template_cloned" &&
            $router.currentRoute.name === "Settings" &&
            $router.currentRoute.params.tab === "templates"
          ) {
            EventBus.$emit("reloadTemplates");
          }
          if (data.short_type === "visitors_sync_failed" || data.short_type === "visitors_synced") {
            $store.dispatch("setVisitorSyncTimestamp", Date.now());
            $store.dispatch("setVisitorSyncRunning", false);
          }
        }
        if (data.short_type) {
          if (data.short_type === "visitors_sync_failed") {
            sendErrorNotification();
          } else {
            sendSuccessNotification();
          }
        }
        function sendErrorNotification() {
          snotify.error(setBody(data), setTitle(data), {
            timeout: 0,
            icon: errorIcon,
          });
        }
        function sendSuccessNotification() {
          snotify
            .success(setBody(data), setTitle(data), {
              icon: successIcon,
            })
            .on("click", () => {
              if (data.project_uid) {
                $store.dispatch("setSingleNotificationStatus", {
                  notification: data.uid,
                  params: {
                    read_at: true,
                  },
                });
                if (data.short_type === "project_message") {
                  $store.commit("GLOBAL_SET_REDIRECTED_INBOX_PROJECT", data.project_uid);
                  $router.push("/t/" + team + "/inbox/");
                } else if (data.short_type === "project_file_signed") {
                  $router.push("/t/" + team + "/projects/" + data.project_uid + "/history/projectfilesignings");
                } else if (
                  data.short_type === "file_approval_version_approved" ||
                  data.short_type === "file_approval_version_rejected"
                ) {
                  $router.push("/t/" + team + "/projects/" + data.project_uid + "/fileapproval");
                } else {
                  $router.push("/t/" + team + "/projects/" + data.project_uid + "/overview");
                }
              }
            });
        }
      });
    }
    $store.commit("GLOBAL_SET_PUSHER_INIT", { teamUid: team, state: true });
  },
};

function setTitle(event) {
  switch (event.short_type) {
    case "file_download":
      return i18n.t("activity.fileDownload.title");
    case "file_upload":
      return i18n.t("activity.fileUpload.title");
    case "file_preview":
      return i18n.t("activity.filePreview.title");
    case "page_view":
      return i18n.t("activity.pageView.title");
    case "project_file_signed":
      return i18n.t("activity.projectFileSigning.title");
    case "project_message":
      return i18n.t("activity.projectMessage.title");
    case "template_cloned":
      return i18n.t("activity.templateCloned.title");
    case "file_approval_version_approved":
      return i18n.t("activity.fileApprovalVersionApproved.title");
    case "file_approval_version_rejected":
      return i18n.t("activity.fileApprovalVersionRejected.title");
    case "form_response":
      return i18n.t("activity.formResponse.title");
    case "visitors_sync_failed":
      return i18n.t("toasts.error");
    case "visitors_synced":
      return i18n.t("toasts.success");
  }
}
function setBody(event) {
  switch (event.short_type) {
    case "file_download":
      return removeTags(
        i18n.t("activity.fileDownload.text", {
          beforeText: setText(event.client_name, event.project_title),
          name: event.file_title,
          clientName: event.client_name,
        })
      );
    case "file_upload":
      return removeTags(
        i18n.t("activity.fileUpload.text", {
          beforeText: setText(event.client_name, event.project_title),
          name: event.file_title,
          clientName: event.client_name,
        })
      );
    case "file_preview":
      return removeTags(
        i18n.t("activity.filePreview.text", {
          beforeText: setText(event.client_name, event.project_title),
          name: event.file_title,
          clientName: event.client_name,
        })
      );
    case "page_view":
      return removeTags(
        i18n.t("activity.pageView.text", {
          beforeText: setText(event.client_name, event.project_title),
          name: event.page_name,
          clientName: event.client_name,
        })
      );
    case "project_file_signed":
      return removeTags(
        i18n.t("activity.projectFileSigning.text", {
          beforeText: setText(event.client_name, event.project_title),
          fileName: event.file_title,
          clientName: event.client_name,
        })
      );
    case "project_message":
      return removeTags(
        i18n.tc("activity.projectMessage.dropdownText", event.message_body.length, {
          beforeText: setText(event.client_name, event.project_title),
          message: event.message_body.replace(/<br\/>/gi, ""),
          num: 1,
        })
      );
    case "template_cloned":
      return i18n.t("activity.templateCloned.text");
    case "file_approval_version_approved":
      return removeTags(
        i18n.t("activity.fileApprovalVersionApproved.text", {
          beforeText: setText(event.client_name, event.project_title),
          name: event.file_approval_name,
        })
      );
    case "file_approval_version_rejected":
      return removeTags(
        i18n.t("activity.fileApprovalVersionRejected.text", {
          beforeText: setText(event.client_name, event.project_title),
          name: event.file_approval_name,
        })
      );
    case "form_response":
      return removeTags(
        i18n.t("activity.formResponse.text", {
          beforeText: setText(event.client_name, event.project_title),
          clientName: event.client_name,
        })
      );
    case "visitors_sync_failed":
      return i18n.t("activity.visitorSync.failedText");
    case "visitors_synced":
      return i18n.t("activity.visitorSync.successText");
  }
}
function setText(client, project) {
  return project + ": " + client + " ";
}
function removeTags(str) {
  if (str === null || str === "") return false;
  else str = str.toString();
  return str.replace(/(<([^>]+)>)/gi, "");
}
